import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../styles/Hero.css';
import ZodiacWheel from './ZodiacWheel';
import WearGuide from './WearGuide';
import { useNavigate } from 'react-router-dom';
import useSectionView from '../utils/useSectionView';
import { trackEvent, trackPlanetGuideOpen } from '../utils/analytics';


const Hero = () => {
  // Floating image animations
  const navigate = useNavigate();
  const [showGuide, setShowGuide] = useState(false);
  const sectionRef = useSectionView('hero');

  const openGuide = () => {
    setShowGuide(true);
    trackPlanetGuideOpen('hero');
  };

  const goToShop = () => {
    trackEvent('cta_click', { cta: 'explore_collection', cta_location: 'hero' });
    navigate('/shop');
  };

  const floatingVariants = {
    animate: {
      y: [0, -20, 0],
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const floatingVariants2 = {
    animate: {
      y: [0, -15, 0],
      x: [0, 10, 0],
      transition: {
        duration: 4,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const floatingVariants3 = {
    animate: {
      y: [0, -25, 0],
      x: [0, -10, 0],
      transition: {
        duration: 3.5,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  return (
    <section className="hero-light" id="home" ref={sectionRef}>
      <ZodiacWheel />
      {/* Floating Images */}
      <motion.div 
        className="floating-image floating-1"
        variants={floatingVariants}
        animate="animate"
      >
        <div className="image-circle">
          <img src="/img/gems/gem1.jpeg" alt="Crystal" />
        </div>
      </motion.div>

      <motion.div 
        className="floating-image floating-2"
        variants={floatingVariants2}
        animate="animate"
      >
        <div className="image-circle">
          <img src="/img/gems/gem2.jpeg" alt="Crystal" />
        </div>
      </motion.div>

      <motion.div 
        className="floating-image floating-3"
        variants={floatingVariants3}
        animate="animate"
      >
        <div className="image-circle">
          <img src="/img/gems/gem3.jpeg" alt="Crystal" />
        </div>
      </motion.div>

      <motion.div 
        className="floating-image floating-4"
        variants={floatingVariants}
        animate="animate"
        transition={{ delay: 0.5 }}
      >
        <div className="image-circle small">
          <img src="/img/gems/gem4.jpeg" alt="Crystal" />
        </div>
      </motion.div>

      {/* <motion.div 
        className="floating-image floating-5"
        variants={floatingVariants2}
        animate="animate"
        transition={{ delay: 1 }}
      >
        <div className="image-circle small">
          <img src="/images/crystal-5.jpg" alt="Crystal" />
        </div>
      </motion.div> */}

      {/* Main Content */}
      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <motion.h1 
            className="hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            Luxe Little Treasures
          </motion.h1>
          
          <motion.p 
            className="hero-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
          >
            Every single piece you'll find here is made to be treasured for a lifetime, 
            handpicked crystals and spiritual treasures to elevate your energy.
          </motion.p>
          
          <motion.button 
            className="hero-cta"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={goToShop}
          >
            EXPLORE COLLECTION
          </motion.button>

          <motion.button
            className="hero-cta"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={openGuide}
          >
            HOW TO WEAR YOUR GEMSTONE
          </motion.button>
        </motion.div>
      </div>

      {/* Same wearing guide the button further down the page opens; the
          birth-number calculator lives inside its step 3. */}
      <WearGuide isOpen={showGuide} onClose={() => setShowGuide(false)} />

      {/* Decorative Elements */}
      <div className="sparkle sparkle-1">✨</div>
      <div className="sparkle sparkle-2">✨</div>
      <div className="sparkle sparkle-3">✨</div>
    </section>
  );
};

export default Hero;